import { render, staticRenderFns } from "./ImgUpload.vue?vue&type=template&id=193a0021"
import script from "./ImgUpload.vue?vue&type=script&lang=js"
export * from "./ImgUpload.vue?vue&type=script&lang=js"
import style0 from "./ImgUpload.vue?vue&type=style&index=0&id=193a0021&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports